import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SEARCH_DEBOUNCE_TIME, SEARCH_MAX_LENGTH } from '@autocomplete';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AutocompleteService } from '../autocomplete.service';

@Component({
  selector: 'app-autocomplete-search',
  templateUrl: './autocomplete-search.component.html',
  styleUrls: ['./autocomplete-search.component.scss'],
})
export class AutocompleteSearchComponent implements OnInit {
  @Input() loading: boolean = false;

  @Input() searchDebounce: number = SEARCH_DEBOUNCE_TIME;

  @Input() searchMaxLength: number = SEARCH_MAX_LENGTH;

  @Input() placeholder: string = 'Пошук у контактах за ПІБ';

  @Output() searchTextInput: EventEmitter<string> = new EventEmitter<string>();

  control: UntypedFormControl = new UntypedFormControl();

  inputFocused: boolean = false;

  constructor(private autocompleteService: AutocompleteService) {
  }

  ngOnInit(): void {
    this.initInputValueSubscription();
    this.initResetSearchSubscription();
  }

  initResetSearchSubscription(): void {
    this.autocompleteService.resetSearch$.subscribe(() => {
      this.control.reset('');
    });
  }

  initInputValueSubscription(): void {
    this.control.valueChanges
      .pipe(debounceTime(this.searchDebounce), distinctUntilChanged())
      .subscribe((query) => {
        this.searchTextInput.emit(query);
      });
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.control.reset('');
    this.searchTextInput.emit('');
  }

  onBlur(event): void {
    event.preventDefault();
    if (
      !event.relatedTarget ||
      (event.relatedTarget &&
        (event.relatedTarget as any).innerText !== 'close')
    ) {
      this.inputFocused = false;
    }
  }

  onFocus(): void {
    this.inputFocused = true;
  }
}
